// extracted by mini-css-extract-plugin
export default {"settings":"VFzrhlkLQpf4kLfSVaH6","layout":"GqpSutwvnez9XOKzrnmk"};